import { CommonModule, Location } from "@angular/common";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  forwardRef,
  inject,
} from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { IonAccordionGroup, IonContent, IonInput, IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

import { EventsService } from "@providers/EventsService";
import { SearchService } from "@providers/SearchService";
import { TrackingService } from "@providers/TrackingService";
import { NewBaseService } from "@providers/newBase.service";
// Services
import { SportNavigationService, SportService } from "@sports-services/index";

import { GlobalVarsModel } from "@models/ModelGlobalsVar";

// Routes
import { MSO_PATHS, SPORTS_PATHS } from "@shared-constants/routes";

// Store
import { Store } from "@ngrx/store";
import { DeviceService } from "@services/device.service";
import { C_Event, C_GameTypes } from "@sports-models/index";
import { C_EventLive } from "@sports-models/index";
import { C_HighLight } from "@sports-models/index";
import { C_Horses } from "@sports-models/index";
import { C_League } from "@sports-models/index";
import { C_SearchResult } from "@sports-models/index";
import { C_SpecialSports } from "@sports-models/index";
import { C_Sport, C_SportSidebar } from "@sports-models/index";
import { SidebarFacade } from "@sports-stores/sidebar/index";
import { SportsbookState } from "@sports-stores/sportsbook/sportsbook.reducers";
import * as sportsbookSelector from "@sports-stores/sportsbook/sportsbook.selectors";

// Utils
import { SportHandleList } from "@sports-utils/index";
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from "rxjs";

@Component({
  standalone: true,
  imports: [CommonModule, IonicModule, RouterModule, TranslateModule],
  selector: "codere-sidebar-pc",
  templateUrl: "./codere-sidebar-pc.html",
  styleUrls: ["./codere-sidebar-pc.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CodereSidebarPcComponent implements OnChanges, OnDestroy {
  @ViewChild("SportsSidebar") SportsSidebar: IonAccordionGroup;
  @ViewChild("searchInput", { static: false }) searchInput: IonInput;
  @ViewChild(IonContent) content: IonContent;

  //es necesario hacer input de las variables y métodos de la app.
  @Input() highlights: C_HighLight[];
  @Input() highlightsConfig: C_SpecialSports[] = [];
  @Input() sports: any;
  @Input() selectedSport: any;

  league: any;
  highLightSports: any = [];

  globalMenuAnimated: boolean = false;
  specialGames: any[] = [];

  searchTermItems: any[] = [];
  searchTerm: any;

  sportsItems: C_SportSidebar[] = [];

  restore = false;
  @ViewChildren("subMenu") arrSubMenu: QueryList<ElementRef>;

  globalVars!: GlobalVarsModel;

  isMobile: boolean;
  countrySelected = null;
  lastScrollPosition = 0;
  gameTypes: C_GameTypes;
  private ngUnsubscribe$ = new Subject<boolean>();

  public router: Router = inject(Router);
  public sportService: SportService = inject(SportService);
  public events: EventsService = inject(EventsService);
  private newBaseService: NewBaseService = inject(NewBaseService);
  private eventService = inject(EventsService);
  private location = inject(Location);
  private sportNavigationService = inject(SportNavigationService);
  public sidebarFacade = inject(SidebarFacade);
  public searchService = inject(SearchService);
  deviceService = inject(DeviceService);
  changeDetectorRef = inject(ChangeDetectorRef);
  sportsbookStore = inject(Store<SportsbookState>);

  constructor(@Inject(forwardRef(() => TrackingService)) private trackingService: TrackingService) {
    this.isMobile = this.deviceService.isMobile();
    this.newBaseService.getVars.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((data: GlobalVarsModel) => {
      this.globalVars = data;
    });
    this.sportsbookStore
      .select(sportsbookSelector.getGameTypeConfig)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(({ gameTypes }) => {
        this.gameTypes = new C_GameTypes(gameTypes);
      });
    this.sportNavigationService.navigationState$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((navigationState) => {
        if (
          navigationState.currentUrl.state.isLeftMenuAZ &&
          this.sportNavigationService.isLastNodeRestored(navigationState.currentUrl.state.sportsNavigationId) &&
          navigationState.currentUrl.popstate
        ) {
          const sportItemSelected = this.sportsItems.find(
            (sport) => sport.SportHandle === navigationState.currentUrl.state.params.SportHandle,
          );
          if (sportItemSelected) {
            this.sidebarFacade.selectedSport = sportItemSelected;
            this.selectedSport = sportItemSelected;
            if (this.selectedSport.highlight.length) {
              const league = this.selectedSport.highlight.find(
                (country) => country.NodeId === navigationState.currentUrl.state.params.NodeId,
              );
              if (league) {
                this.countrySelected = league.NodeId;
                this.league = league;
              } else {
                if (this.selectedSport.countries?.data?.length) {
                  for (
                    let dataPosition = 0;
                    dataPosition < this.selectedSport.countries.data.length;
                    dataPosition++
                  ) {
                    const league = this.selectedSport.countries.data[dataPosition].Leagues.find(
                      (country) =>
                        country.NodeId === navigationState.currentUrl.state.params.NodeId ||
                        country.NodeId === navigationState.currentUrl.state.params.ParentNodeId,
                    );
                    if (league) {
                      this.sidebarFacade.openSection(this.selectedSport);
                      this.countrySelected = this.selectedSport.countries.data[dataPosition].NodeId;
                      this.league = league;
                    }
                  }
                }
              }
            } else if (this.selectedSport.countries?.data?.length) {
              for (let dataPosition = 0; dataPosition < this.selectedSport.countries.data.length; dataPosition++) {
                const league = this.selectedSport.countries.data[dataPosition].Leagues.find(
                  (country) =>
                    country.NodeId === navigationState.currentUrl.state.params.NodeId ||
                    country.NodeId === navigationState.currentUrl.state.params.ParentNodeId,
                );
                if (league) {
                  this.countrySelected = this.selectedSport.countries.data[dataPosition].NodeId;
                  this.league = league;
                }
              }
            } else if (
              !this.selectedSport.highlight.length &&
              !this.selectedSport.countries?.data?.length &&
              this.selectedSport.isCollapsible
            ) {
              this.cleanSelection();
            }
            this.changeDetectorRef.detectChanges();
          }
          if (navigationState.currentUrl.state.isLeftMenuAZ) {
            setTimeout(() => {
              this.content.scrollToPoint(undefined, navigationState.currentUrl.state.isLeftMenuAZ || 0, 250);
            }, 150);
          }
        }
        if (
          !navigationState.currentUrl.state.isLeftMenuAZ ||
          (navigationState.currentUrl.popstate &&
            !this.sportNavigationService.isLastNodeRestored(navigationState.currentUrl.state.sportsNavigationId))
        ) {
          this.cleanSelection();
        }
      });

    this.searchService.searchTerm
      .pipe(debounceTime(800), distinctUntilChanged())
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((search) => this.search(search));
  }

  ngOnChanges(changes: SimpleChanges) {
    this.sportsItems = this.sports;
    this.highLightSports = this.highlights;
    const hasSelectedSport = changes.selectedSport && !changes.selectedSport.firstChange;
    const currentAndPreviousSportSelectedAreEqual =
      changes.selectedSport &&
      changes.selectedSport.currentValue?.SportHandle === changes.selectedSport.previousValue?.SportHandle;
    const countriesOfSelectedSportJustArrived =
      changes.selectedSport?.previousValue?.countries.loading &&
      !changes.selectedSport?.currentValue?.countries.loading;
    const hasSomeTarget =
      changes.selectedSport &&
      (changes.selectedSport.currentValue?.highlight.length ||
        changes.selectedSport.currentValue?.countries?.data?.length);
    const dataHasJustArrivedAfterClicking =
      hasSelectedSport &&
      currentAndPreviousSportSelectedAreEqual &&
      countriesOfSelectedSportJustArrived &&
      hasSomeTarget;
    if (dataHasJustArrivedAfterClicking) {
      if (
        changes.selectedSport.currentValue.highlight.length > 0 &&
        !changes.selectedSport.currentValue.isCollapsible
      ) {
        this.league = changes.selectedSport.currentValue.highlight[0];
        this.router.navigate(["SportEventsPage"], {
          state: {
            params: changes.selectedSport.currentValue,
            isLeftMenuAZ: this.lastScrollPosition?.toString() || "0",
          },
          queryParams: { animate: !this.globalVars.isNative },
        });
      } else {
        if (changes.selectedSport.currentValue.countries.data.length > 0) {
          if (changes.selectedSport.currentValue.countries.data[0].Leagues.length > 0) {
            this.league = changes.selectedSport.currentValue.countries.data[0].Leagues[0];
            this.countrySelected = changes.selectedSport.currentValue.countries.data[0].NodeId;
            this.navigate(this.league);
            this.trackingService.trackEvent([
              "AccesstoLeagueFromCountryItemsportMenu",
              this.league.Name,
              this.league.SportHandle,
              this.league.NodeId,
              "event",
            ]);
          }
        }
      }
    }
  }

  openMvpCodere() {
    this.cleanSelection();
    this.router.navigate([`${MSO_PATHS.BASE}/${MSO_PATHS.MvpCoderePage}`]);
  }

  isOpenSelectedSport() {
    return this.sidebarFacade.selectedSport !== null;
  }

  openSpecialSport(sport, menu) {
    this.cleanSelection();
    this.globalVars.rootScope.openSpecialSport(sport, menu);
  }

  openSpecialGame(specialG) {
    this.cleanSelection();
    this.globalVars.rootScope.openSpecialGame(specialG);
  }

  openSpecialTeam(specialT) {
    this.cleanSelection();
    this.globalVars.rootScope.openSpecialTeam(specialT);
  }

  openCodereMillion() {
    this.cleanSelection();
    this.globalVars.rootScope.openCodereMillion();
  }

  openToday() {
    this.cleanSelection();
    this.router.navigate([SPORTS_PATHS.TodayPage]);
    this.trackingService.trackEvent(["AccessToHoy", "", "sportmenu", "Hoy", "event"]);
  }

  openBetbuilder() {
    this.cleanSelection();
    this.globalVars.rootScope.openBetbuilder();
  }

  openWorldCupCalendar() {
    this.router.navigate([MSO_PATHS.InformationPage, { type: "politicapriv" }, { animate: this.isMobile }]);
  }

  openCodereFantasy() {
    this.cleanSelection();
    this.globalVars.rootScope.openCodereFantasy();
  }

  toggleSport(sport: any) {
    if (sport.NodeId === this.sidebarFacade.selectedSport?.NodeId) {
      if (this.selectedSport) {
        this.sidebarFacade.selectedSport = null;
        this.toggleSportTrackingService(sport, this.isOpenSelectedSport());
      }
    } else {
      this.toggleSportTrackingService(sport, this.isOpenSelectedSport());
      this.sidebarFacade.selectedSport = sport;
      if (!sport.isCollapsible) {
        this.navigateToNoDropdownSports(sport);
      } else {
        this.getSportItems(sport);
      }
    }
  }

  getSportItems(sport) {
    this.sidebarFacade.fetchCountries(sport);
  }

  navigateToNoDropdownSports(sport) {
    switch (sport.SportHandle) {
      case SportHandleList.horse_racing:
      case SportHandleList.greyhound_racing:
        this.router.navigate([SPORTS_PATHS.HorsesPage], {
          state: { params: sport, isLeftMenuAZ: this.lastScrollPosition?.toString() || "0" },
          queryParams: { animate: !this.globalVars.isNative },
        });
        break;
      default:
        this.router.navigate([SPORTS_PATHS.SportCountriesPage], {
          state: {
            params: { Name: sport.Name, NodeId: sport.NodeId, SportHandle: sport.SportHandle },
            isLeftMenuAZ: this.lastScrollPosition?.toString() || "0",
          },
        });
        break;
    }
  }

  navigateToNoDropdownSportsAfterClean(hs) {
    this.cleanSelection();
    this.navigateToNoDropdownSports(hs);
  }

  toggleSportTrackingService(sport, collapsed) {
    this.trackingService.trackEvent([
      collapsed ? "OpenItemSportMenu" : "CollapsedItemSportMenu",
      sport.SportHandle,
      this.globalVars.currentPage.name,
      "",
      "event",
    ]);
  }

  toggleSection(sport: C_Sport) {
    this.sidebarFacade.toggleSection(sport);
    this.trackingService.trackEvent([
      "ViewMoreItemSports",
      sport.countries.collapsed,
      this.globalVars.currentPage.name,
      "",
      "event",
    ]);
  }

  itemLeagueTapped(event: Event, league: C_League, sport: C_Sport, isHL: boolean = false): void {
    this.league = league;
    if (this.league.SportHandle !== "greyhound_racing" && this.league.SportHandle !== "horse_racing") {
      this.navigate(this.league);
    } else {
      this.router.navigate([SPORTS_PATHS.HorsesPage], {
        state: { params: sport, isLeftMenuAZ: this.lastScrollPosition?.toString() || "0" },
        queryParams: { animate: !this.globalVars.isNative },
      });
    }
    this.trackingService.trackEvent([
      isHL ? "AccesstoLeagueFromHLItemsportMenu" : "AccesstoLeagueFromCountryItemsportMenu",
      this.league.Name,
      this.league.SportHandle,
      this.league.NodeId,
      "event",
    ]);
  }

  async navigate(league: any) {
    let componentName: string = SPORTS_PATHS.EventoPage;
    let params = league;
    const leagueName = league.Name.toLowerCase();
    if (leagueName.search("anticipadas") >= 0 || leagueName.search("especiales") >= 0) {
      const data = await this.sportService.getEventsCountry(league.NodeId).toPromise();
      if (data.length === 1) {
        componentName = SPORTS_PATHS.MercadosPage;
        params = data[0];
      }
    }
    const hasBackButton: string = this.router.routerState.snapshot.url;
    this.eventService.sendCanGoBack(hasBackButton === "/HomePage" ? true : false);
    switch (componentName) {
      case SPORTS_PATHS.EventoPage:
        this.router.navigate([componentName], {
          state: { params: params, isLeftMenuAZ: this.lastScrollPosition?.toString() || "0" },
        });
        break;
      case SPORTS_PATHS.MercadosPage:
        this.router.navigate([componentName], {
          state: { params: params, isLeftMenuAZ: this.lastScrollPosition?.toString() || "0" },
        });
        break;
    }
  }

  showSportHandleContent(sportHandle) {
    let showContent = true;
    switch (sportHandle) {
      case "soccer":
      case "tennis":
      case "basketball":
      case "olimpiadas":
      case "greyhound_racing":
      case "horse_racing":
        showContent = false;
        break;
    }
    return showContent && !!this.sidebarFacade.selectedSport;
  }

  selectedCountryChange(event) {
    this.countrySelected = +event?.detail?.value;
  }

  // SEARCH
  searchOutOfFocus(ev) {
    this.searchIonInput(ev);
  }

  searchIonInput(ev) {
    if (ev?.detail?.value) {
      this.searchService.searchTerm.next(ev?.detail?.value);
    } else {
      this.searchService.searchTerm.next(ev?.detail?.value);
      this.clearSearchTerms();
    }
  }

  clearSearchTerms() {
    this.searchTermItems = [];
  }

  search(term: string) {
    if (term) {
      this.searchService
        .getResultSearch(term)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((results: any) => {
          this.searchTermItems = results;
        });
    }
  }

  btItemSearch_Click($DOMevent, item: C_SearchResult) {
    this.cleanSelection();
    this.clearSearchTerms();
    if (item.SportHandle === "greyhound_racing" || item.SportHandle === "horse_racing") {
      const objHorsesAux: C_Horses = new C_Horses(
        item.Name,
        item.NodeId,
        item.ParentNodeId,
        item.EventNodeTypeId,
        item.Priority,
        item.SportHandle,
        item.ChildrenCount,
        item.Country,
        false,
        0,
        item.PaddockId,
        item.StartDate,
      );
      this.router.navigate(["HorsesMarketPage"], {
        state: { params: objHorsesAux },
      });
    } else {
      if (item.isLive) {
        const event = C_EventLive.parse(item);
        const eventGameTypes = this.gameTypes.getOne(event.SportHandle, event.CountryCode, event.isLive);
        event.setGamesByPlatform(eventGameTypes, this.isMobile);
        this.router.navigate(["NowLiveDetailPage"], {
          state: { params: event },
        });
      } else {
        const event = C_Event.parse(item);
        const eventGameTypes = this.gameTypes.getOne(event.SportHandle, event.CountryCode, event.isLive);
        event.hasSpecialGame(this.gameTypes.apuestas_especiales);
        event.setGamesByPlatform(eventGameTypes, this.isMobile);
        this.router.navigate(["MercadosPage"], {
          state: { params: event },
        });
      }
    }
  }

  cleanSelection() {
    this.sidebarFacade.selectedSport = null;
    this.league = null;
    this.sidebarFacade.closeAllSection();
  }

  trackAZ(index, item) {
    return item.SportHandle;
  }

  onScroll(event) {
    this.lastScrollPosition = event.detail.scrollTop;
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }
}
